import Home from '@app/components/parents/Home'
import Children from '@app/components/parents/Children'
import Diplomas from '@app/containers/parents/Diplomas'
import Statistics from '@app/components/parents/Statistics'

export default {
  Home: {
    component: Home,
    exact: true,
    path: '/parents/home'
  },
  Children: {
    component: Children,
    exact: true,
    path: '/parents/children'
  },
  Statistics: {
    component: Statistics,
    exact: true,
    path: '/parents/statistics'
  },
  Diplomas: {
    component: Diplomas,
    exact: true,
    path: '/parents/children/diplomas'
  }
}
